<template>
  <div class="v2-badge-description">
    <h4 class="mb-1" v-html="title" />
    <span v-if="description">{{ description }}</span>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "badge-description",
});

defineProps({
  title: {
    type: String,
    require: true,
    default: "",
  },
  description: {
    type: String,
    require: false,
    default: "",
  },
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
